export const config = {
    rowSelection: false,
    fieldControl: false,
    columns: [
        {title: 'ID', dataIndex: 'id', width: 200},
        {title: '任务标题', dataIndex: 'title', width: 200, ellipsis: true},
        {title: '任务描述', dataIndex: 'description', width: 200, ellipsis: true},
        {title: '任务类型', dataIndex: 'name', width: 200, ellipsis: true},
        {title: '跳转链接', dataIndex: 'link', width: 200, render: 'date'},
        {title: '关联事件库', dataIndex: 'memberEventTypeName', width: 200,},
        {title: '状态', dataIndex: 'state', width: 120, render: 'switchRender'},
        {title: '排序', dataIndex: 'orderSeq', width: 120,},
        {title: '最后更新人', dataIndex: 'modifiedByName', width: 200,},
        {title: '最后更新时间', dataIndex: 'lastUpdatedTime', width: 200,},
        {title: '操作', dataIndex: 'action', fixed: 'right', width: 120, render: 'actionRender'},
    ],
    search: [
        {label: '任务标题', name: 'title'},
        {label: '状态', name: 'state', itemType: 'select', key: 'value', data: 'stateTypeList'},
        {label: '任务类型', name: 'type', itemType: 'select', key: 'value', data: 'taskTypeList'},
    ],
    footer: [
        {label: '新增', type: 'primary', events: ['onClick:onAdd']}
    ]
}
